import { render, staticRenderFns } from "./Informa.vue?vue&type=template&id=9f6ede1e"
import script from "./Informa.vue?vue&type=script&lang=js"
export * from "./Informa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports